import { parseLocalDate } from '@/shared/i18n/dateUtils';
import { ConfigurationFormData } from './formData';

export const MAX_RANGES = 100;
export const MAX_SPAN_YEARS = 5;

type Violation = { id: string; values: Record<string, number> } | null;

export function limitViolation(data: ConfigurationFormData): Violation {
  if (data.windows.length > MAX_RANGES) {
    return { id: 'accounts.configForm.tooManyWindows', values: { max: MAX_RANGES } };
  }

  if (data.blackouts.length > MAX_RANGES) {
    return { id: 'accounts.configForm.tooManyBlackouts', values: { max: MAX_RANGES } };
  }

  return spanViolation(data.windows);
}

function spanViolation(windows: ConfigurationFormData['windows']): Violation {
  const dated = windows.filter((window) => window.from && window.to);
  if (dated.length === 0) return null;

  const earliest = dated.map((window) => window.from).toSorted()[0];
  const latest = dated.map((window) => window.to).toSorted().at(-1);
  if (!latest) return null;

  const limit = parseLocalDate(earliest);
  limit.setFullYear(limit.getFullYear() + MAX_SPAN_YEARS);

  return parseLocalDate(latest) > limit
    ? { id: 'accounts.configForm.spanTooLong', values: { years: MAX_SPAN_YEARS } }
    : null;
}

const SERVER_FIELDS: Record<string, keyof ConfigurationFormData> = {
  min_days_from_now: 'minDaysFromNow',
  max_gap_between_asc_and_consular: 'maxGapAscConsular',
  min_same_day_gap: 'minSameDayGap',
  accept: 'windows',
  exclude: 'blackouts',
};

export function formFieldFor(serverField?: string): keyof ConfigurationFormData | undefined {
  return serverField ? SERVER_FIELDS[serverField] : undefined;
}
